import { makeStyles } from "@material-ui/core/styles";
import { toolbarHeight, filterToolbarHeight } from "components/app/Styles";
import theme from "theme";
// const vh = (window.innerHeight) * 0.01
export const filterContainerHeight = 0;
export const chartTitleHeight = 68;
export const aboutDrawerWidth = 343;
export const chartDrawerWidth = 390;
export const chartTogglebarWidth = 68;
export const aboutTogglebarWidth = 68;

const useStyles = makeStyles(
  {
    "@global": {
      html: {
        height: "100%",
      },
      body: {
        margin: "0",
        height: "100%",
        fontFamily: "Arial, sans-serif",
      },
    },
    chartContent: {
      maxWidth: '150px',
    },
    mobileContent: {
      fontSize: '14px',
    },
    browserContent: {
      fontSize: '16px',
    },
    chartContentBoldText: {
      fontSize: "16px",
      fontWeight: "bold",
    },
    filterContainer: {
      minHeight: filterContainerHeight,
      // width: "100%", <- this leaves a small gap at the end of screen
      width: `calc(100vw + 8px)`,
      backgroundColor: "#E5E9EE",
      display: "flex",
      alignItems: "center",
      paddingLeft: 64,
      paddingRight: 64,
      paddingTop: 8,
      // paddingBottom: 8,
      boxShadow: "0px 3px 6px #00000029",
      cursor: "pointer",
      zIndex: 1,
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    expandBtn: {
      background: "#FFFFFF",
      position: "absolute",
      bottom: -10,
      left: `calc(50vw - 35px)`,
      maxHeight: 25,
      paddingLeft: 8,
      paddingRight: 8,
      boxShadow: "0px 3px 6px #00000029",
      border: 0,
      color: "#757575",
      fontSize: 14,
      "& .MuiButton-startIcon": {
        marginRight: 0,
      },
      "&:hover": {
        background: "#FFFFFF",
      },
    },
    applyBtn: {
      marginTop: 24,
      textTransform: "uppercase",
    },
    filterSelect: {
      borderRadius: 0,
      minWidth: 200,
      marginTop: 16,
      marginBottom: 8,
      marginRight: 16,
      height: 61,
      "& .MuiOutlinedInput-input": {
        padding: 8,
        fontSize: 16,
      },
      "& .MuiInput-formControl": {
        marginTop: 24,
        paddingTop: 4,
        marginBottom: 8,
        border: "1px solid #ccc",
      },
      "& .MuiInput-underline:before": {
        borderBottom: 0,
        "&:hover": {
          borderBottom: 0,
        },
      },
      "& .MuiSelect-icon": {
        marginRight: 8,
      },
      "& .MuiSelect-select": {
        paddingLeft: 16,
        marginBottom: 4,
      },
    },
    filterSelectLabel: {
      marginBottom: 4,
    },
    chips: {
      display: "flex",

      alignItems: "center",
    },
    chip: {
      color: "#707070",
      paddingTop: 18,
      paddingBottom: 18,
      paddingLeft: 25,
      paddingRight: 25,
      borderRadius: 40,
      fontSize: 12,
      marginRight: 18,
      "& .MuiChip-label": {
        padding: 0,
      },
    },
    mainView: {
      // position: "fixed",
      // top: `calc(${toolbarHeight}px + ${filterContainerHeight}px)`,
    },
    chartTogglebar: {
      width: chartTogglebarWidth,
      display: "flex",
      //position: "fixed",
      flexDirection: "row",
      //height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
      backgroundColor: "#323232",
      boxShadow: "0px 3px 6px #00000080",
    },
    chartTogglebarChild: {
      height: '100% !important',
      zIndex: 1002,
    },
    chartToggleIcon: {
      width: 26,
      height: 15,
      paddingTop: 40,
      paddingBottom: 30,
      paddingLeft: 21,
      paddingRight: 21,
      cursor: "pointer",
    },
    chartTabs: {
      display: "inline-flex",
      alignItems: "start",
      "& .MuiTabs-indicator": {
        display: "none",
      },
      "& .Mui-selected": {
        background: "#718CD4",
        "&:hover": {
          background: "#718CD4",
        },
      },
    },
    chartTab: {
      minWidth: 68,
      marginBottom: 8,
      paddingBottom: 0,
      paddingTop: 0,
      backgroundColor: "#1E1E1E",
      opacity: 1,
      marginTop: 0,
      "&:hover": {
        backgroundColor: "#4B5A84",
      },
      height: `75px`,
    },
    chartIconPlaceholder: {
      height: 120,
      width: "1.1em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    chartDrawer: {
      width: chartDrawerWidth,
      position: "absolute",
      zIndex: 500,
      top: 0,
      left: 68,
      height: `calc($100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
      backgroundColor: "#F5F5F5",
      boxShadow: "0px 3px 6px #00000060",
    },
    chartHeader: {
      // height: chartTitleHeight,
      // paddingTop: 26,
      // paddingBottom: 21,
      paddingLeft: 64,
      marginBottom: 16,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: 'wrap'
    },
    chartHeaderResponsive: {
      minHeight: 68,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 25,
      // display: "flex",
      alignItems: "center",
      width: "89%"
    },
    chartHeaderTitle: {
      display: "none", // As per the current requirements we don't show title when we're viewing on browser
      color: "#0C3588",
      fontSize: '1.3em',
      fontWeight: "bold",
    },
    chartHeaderSubtitle: {
      color: "#000",
      fontSize: 18,
      fontWeight: "bold",
    },
    chartHeaderTitleResponsive: {
      // color: "#2352D0",
      fontSize: 16,
      fontWeight: "bold",
      color: "#000",
    },
    chartHeaderSubtitleResponsive: {
      color: "#000",
      fontSize: 12,
      fontWeight: "bold",
    },
    chartItem: {
      // height: 120,
      height: `75px`,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      paddingLeft: 32,
      paddingRight: 5,
      background: "#E9E9EB",
      marginBottom: 8,
    },
    chartItemTitle: {
      fontSize: 18,
      fontWeight: "bold",
      color: "#383737",
      "&:hover": {
        cursor: "pointer",
      },
      marginRight: "5em",
    },
    chartItemDesc: {
      fontSize: 14,
      "&:hover": {
        cursor: "pointer",
      },
    },
    chart: {
      paddingLeft: 54,
      paddingRight: 54,
    },
    chooseText: {
      fontSize: 30,
      fontWeight: "bold",
      color: "#212121",
      flexGrow: 1,
    },
    aboutTogglebar: {
      width: aboutTogglebarWidth,
      display: "flex",
      height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
      background: "#FFFFFF",
      boxShadow: "0px 3px 6px #00000029",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      position: "relative",
    },
    aboutToggleIcon: {
      width: 37,
      height: 27,
    },
    aboutDrawer: {
      width: aboutDrawerWidth,
      background: "#FFFFFF",
      boxShadow: "0px 3px 6px #00000029",
      overflowY: "auto",
      position: "relative",
      zIndex: 460,
        height: `calc(100vh - ${toolbarHeight}px + ${13}px)`,
        overflow: 'hidden', // hide the scrollbar if it overflows
    },
    metricTitle: {
      marginTop: 16,
      fontSize: 13,
      // paddingLeft: 40,
      marginLeft: 10,
    },
    gaugeMetricTitle: {
      marginTop: 16,
      fontSize: 16,
      paddingLeft: 40,
      marginRight: 10, //this is mainly for the gaugePie metric title chart tab
    },
    cityTitle: {
      // marginTop: 16,
      marginLeft: "26px",
      fontSize: 24,
      color: "#0C3588",
      fontWeight: "bold",
      marginBottom: "20px",
    },
    metricValue1: {
      color: "#000000",
      marginLeft: "26px",
      fontSize: 15,
      marginBottom: "20px",
    },
    metricValue2: {
      color: "#000000",
      marginLeft: "12px",
      fontSize: 15,
      fontWeight: "bold",
      marginBottom: 8,
    },
    metricSubTitle: {
      fontSize: 17,
      fontWeight: "bold",
      marginLeft: "26px",
      color: "#000000",
      marginBottom: "3px",
      marginTop: 18,
    },
    metricSubTitle1: {
      fontSize: 17,
      marginLeft: "12px",
      color: "#000000",
      marginBottom: "3px",
      marginTop: 18,
    },
    gaugeMetricValue: {
      color: "#000000",
      fontSize: 16,
      fontWeight: "bold",
    },
    metricValue: {
      color: "#000000",
      fontSize: 18,
      fontWeight: "bold",
      marginLeft: 10,
      // marginBottom: 40,
    },
    closeBtn: {
      position: "relative",
      left: "93%",
    },
    chartView: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px + 13px)`,
      background: "#E5E9EE",
      [theme.breakpoints.down("md")]: {
        height: `calc(100vh - ${toolbarHeight}px - ${filterToolbarHeight}px - ${aboutTogglebarWidth}px)`,
        overflowY: "scroll",
        flexGrow: null,
        zIndex: 1
      },
    },
    tabs: {
      flexBasis: "auto",
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginBottom: "2vh",
      marginTop: -20,
    },
    tabRoot: {
      "& .MuiTab-wrapper": {
        // textTransform: "uppercase",
      },
      "& .MuiTabs-indicator": {
        background: "none",
        display: "none",
      },
    },
    tabInactive: {
      background: "#FFFFFF",
      color: "#757575",
      minWidth: "auto",
      minHeight: "auto",
      padding: "10px 12px",
      opacity: 1,
      font: "normal normal normal 14px Arial",
      border: "0.5px solid #B8B8B8",
      display: 'flex',
      flexWrap: 'wrap',
      "& .MuiTab-wrapper": {
        width: "auto",
      },
      [theme.breakpoints.up("xl")]: {
        font: "normal normal normal 16px/18px Arial",
      },
      [theme.breakpoints.down("xs")]: {
        display: 'flex',
        flexWrap: 'wrap',
        width: 110
      }
    },
    tabActive: {
      opacity: 1,
      background: "#EBF0FD",
      color: "#2352D0",
      font: "normal normal normal 14px Arial",
    },
    startingTab: {
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
    },
    endingTab: {
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
    },
    sectionTitle: {
      fontSize: 18,
      fontWeight: "bold",
    },
    sectionContent: {
      marginTop: 8,
      marginBottom: 24,
      "& a:link, a:visited": {
        color: "#00A4E0",
      },
    },
    aboutBox: {
      height: "80%",
      overflow: "auto",
    },
    sliderContainer: {
      padding: 8,
      paddingLeft: 15,
      paddingRight: 32,
      backgroundColor: "#FFF",
      width: `40vw`,
      display: "flex",
      justifyContent: "center",
      borderRadius: 10,
      boxShadow: "0px 3px 6px #00000029",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    honeycombSliderContainer: {
      display: 'flex',
      justifyContent: "center",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    honeycombSlider: {
      padding: 8,
      paddingLeft: 32,
      paddingRight: 32,
      backgroundColor: "#FFF",
      borderRadius: 10,
      boxShadow: "0px 3px 6px #00000029",
      width: "40vw",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    citySliderRail: {
      backgroundColor: "#C4C4C4",
      height: "5px",
      borderRadius: 4,
      opacity: 1,
      
    },
    citySliderTrack: {
      height: "5px",
      borderRadius: 4,
    },
    citySliderThumb: {
      height: 15,
      width: 15,
      border: "2px solid currentColor",
      marginTop: -5,
    },
    citySlider: {
      color: "#9CC9F5",
      marginTop: "4px",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    citySliderMark: {
      backgroundColor: "#2F2F2F",
      width: 5,
      height: 5,
      borderRadius: 6,
    },
    cityMarkLabel: {
      color: "#2F2F2F",
      // font: "normal normal normal 11px/12px Arial",
      fontSize: "16px",
      fontFamily: "Arial",
    },
    mapLocationDiv: {
      display: "block",
    },
    map: {
      height: `calc(100vh - 156px)`,
    },
    mapResponsive: {
      height: `calc(100vh - 200px)`,
    },
    mapArea: {
      "& .info": {
        padding: "5px",
        font: "0.8em Arial, Helvetica, sans-serif",
        background: "rgba(255, 255, 255, 1)",
        boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "15px",
        margin: "0px 30px 20px",
      },
      "& .legendTitle": {
        // font: "normal normal bold 1.1em/30px Arial",
        fontFamily: "Arial",
        fontSize: "1.2em",
        fontWeight: "bold",
        color: "#2F2F2F",
        margin: "10px",
      },
      "& .legend": {
        lineHeight: "1vh",
        left: "20px",
      },
      "& .legend i": {
        width: "16px",
        height: "16px",
        float: "left",
        marginRight: "13px",
        opacity: "0.6",
        // borderRadius: "10px",
      },
      "& .legendLabel": {
        // font: "normal normal normal 1.2em/16px Arial",
        fontFamily: "Arial",
        fontSize: "16px",
        color: "#2F2F2F",
      },
      "& .legendContent": {
        // font: "normal normal normal 1.2em/16px Arial",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingLeft: "10px",
        paddingRight: "10px",
      },
      "& .leaflet-top": {
        // ensure leaflet controls on top appear below the title
        // the chartheader has a padding of 50, so we add 55
        top: `${chartTitleHeight + 55}px`,
        [theme.breakpoints.down("md")]: {
          top: chartTitleHeight,
        }
      },
      "& .leaflet-bottom.leaflet-left": {
        // changes zIndex so legend appears below chart drawer
        zIndex: 451,
      },
      "& .leaflet-bottom": {
        // 200px is the width of the slider container
        left: `calc((100% - 200px) / 2)`,
      },
      "& .patternLegend": {
        background: `repeating-linear-gradient(
        135deg,
        #FFFFFF,
        #FFFFFF 2px,
        #808080 2px,
        #808080 5px
      )`,
      },
      "& .industryLegend": {
        border: "1px solid #A7A5A4 ",
        borderRadius: "10px",
      },
    },
    mapAreaResponsive: {
      "& .info": {
        padding: "5px",
        font: "0.8em Arial, Helvetica, sans-serif",
        background: "rgba(255, 255, 255, 1)",
        boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "15px",
        margin: "0px 30px 20px",
      },
      "& .legendTitle": {
        // font: "normal normal bold 1.1em/30px Arial",
        fontFamily: "Arial",
        fontSize: "1.2em",
        fontWeight: "bold",
        color: "#2F2F2F",
        margin: "10px",
      },
      "& .legend": {
        lineHeight: "1vh",
        left: "10px",
      },
      "& .legend i": {
        width: "16px",
        height: "16px",
        float: "left",
        marginRight: "13px",
        opacity: "0.6",
        // borderRadius: "10px",
      },
      "& .legendLabel": {
        // font: "normal normal normal 1.2em/16px Arial",
        fontFamily: "Arial",
        fontSize: "16px",
        color: "#2F2F2F",
      },
      "& .legendContent": {
        // font: "normal normal normal 1.2em/16px Arial",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingLeft: "10px",
        paddingRight: "10px",
      },
      "& .leaflet-top": {
        // ensure leaflet controls on top appear below the title
        // the chartheader has a padding of 50, so we add 55
        top: `${chartTitleHeight}px`,
      },
      "& .leaflet-bottom.leaflet-left": {
        // changes zIndex so legend appears below chart drawer
        zIndex: 451,
      },
      "& .leaflet-bottom": {
        // 200px is the width of the slider container
        left: `calc((100% - 200px) / 2)`,
      },
      "& .patternLegend": {
        background: `repeating-linear-gradient(
        135deg,
        #FFFFFF,
        #FFFFFF 2px,
        #808080 2px,
        #808080 5px
      )`,
      },
      "& .industryLegend": {
        border: "1px solid #A7A5A4 ",
        borderRadius: "10px",
      },
    },
    mapSlider: {
      display: 'flex'
    },
    mapSliderContainer: {
      backgroundColor: "#FFFFFF ",
      boxShadow: "0px 3px 6px #00000029",
      padding: "10px 10px 15px 10px",
      border: "1px solid #E0E0E0",
      borderRadius: "15px",
      height: "250px",
      width: "40px",
    },
    sliderTitle: {
      color: "#2F2F2F",
      // display: "block",
      font: "normal normal bold 13px/18px Arial",
      display: "flex",
      justifyContent: "center",
      // marginBottom: "12px",
      [theme.breakpoints.down("xl")]: {
        font: "normal normal bold 13px/18px Arial",
      },
      [theme.breakpoints.down("lg")]: {
        font: "normal normal bold 12px/16px Arial",
      },
    },
    sliderRail: {
      backgroundColor: "#C4C4C4",
    },
    slider: {
      color: "#9CC9F5",
      marginTop: "4px",
    },
    sliderVertical: {
      "&.MuiSlider-root": {
        height: "80% ",
        padding: "0 45%",
      },
      "&.MuiSlider-marked": {
        marginRight: "0px",
      },
      "& .MuiSlider-rail": {
        width: "5px",
        borderRadius: 4,
      },
      "& .MuiSlider-track": {
        width: "5px",
        borderRadius: 4,
      },
    },
    sliderValueLabel: {
      display: "none",
    },
    sliderThumb: {
      height: 15,
      width: 15,
      border: "2px solid currentColor",
      marginTop: -8,
    },
    sliderLabel: {
      font: "normal normal bold 12px Arial",
      color: "#2F2F2F",
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      verticalAlign: "middle",
      paddingTop: "13px",
      minWidth: "160px",
    },
    chartContainer: {
      // paddingLeft: 54,
      // paddingRight: 54,
      // height: "60vh",
      display: "flex",
      justifyContent: "center",
      marginTop: "15px",
      marginBottom: "15px",
      [theme.breakpoints.up("md")]: {
        width: "100%",
      },
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    chartLegendContainer: {
      display: "flex",
      height: "100%",
      justifyContent: "flex-end",
      alignItems: "flex-end",
      flexDirection: "column",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "row",
        justifyContent: "center",
        marginTop: 16,
        paddingLeft: 16,
        paddingRight: 16
      },
    },
    chartLegend: {
      background: "#FFF",
      padding: "18px 16px",
      borderRadius: 14,
      display: "flex",
      flexDirection: "column",
      marginRight: 24,
      [theme.breakpoints.down("md")]: {
        marginRight: 0,
        paddingLeft: 16
      }
    },
    legendItems: {
      display: 'flex',
      flexDirection: "column",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "row",
        width: "100%",
        flexWrap: "wrap",        
      }
    },
    legendTitle: {
      fontWeight: "bold",
      fontSize: "16px",
      color: "#2F2F2F",
      fontFamily: "Arial",
    },
    polygonLegendTitle: {
      fontWeight: "bold",
      fontSize: "12px",
      color: "#2F2F2F",
      fontFamily: "Arial",
    },
    legendItem: {
      display: "flex",
      alignItems: "center",
      marginTop: 8,
      [theme.breakpoints.down("sm")]: {
        marginRight: 16,
      }
    },
    legendItemColor: {
      width: "15px",
      height: "15px",
    },
    legendItemText: {
      paddingLeft: 8,
      fontSize: 16,
      color: "#2F2F2F",
      fontFamily: "Arial",
    },
    polygonLegendItemText: {
      paddingLeft: 8,
      fontSize: 12,
      color: "#2F2F2F",
      fontFamily: "Arial",
    },
    centralSliderRail: {
      backgroundColor: "#C4C4C4",
      height: "5px",
      borderRadius: 4,
      opacity: 1,
    },
    centralSliderTrack: {
      height: "5px",
      borderRadius: 4,
      backgroundColor: "currentColor !important",
    },
    centralSliderTrackInverted: {
      height: "5px",
      borderRadius: 4,
    },
    centralSliderThumb: {
      height: 15,
      width: 15,
      marginTop: -5,
    },
    centralSlider: {
      color: "#9CC9F5",
      marginTop: "4px",
      width: "85%",
    },
    centralSliderMark: {
      backgroundColor: "#2F2F2F",
      width: 5,
      height: 5,
      borderRadius: 6,
    },
    centralMarkLabel: {
      color: "#2F2F2F",
      // font: "normal normal normal 11px/12px Arial",
      fontSize: "0.9em",
      fontFamily: "Arial",
      transform: "translateX(50%)",
    },
    centralmapSliderContainer: {
      backgroundColor: "#FFFFFF ",
      boxShadow: "0px 3px 6px #00000029",

      border: "1px solid #E0E0E0",
      borderRadius: "15px",
      // height: "250px",
      width: "400px",
      display: "flex",
      justifyContent: "center",
    },
    technicalTooltipPopper: {
      padding: "9px 6px",
      font: "normal normal normal 0.85em/13px Arial",
    },
    sankeyTitle: {
      marginTop: 18,
      fontSize: "16px",
      fontWeight: "bold",
      fontFamily: "Arial",
      color: "rgb(102, 102, 102)",
    },
    aboutDrawerResponsive: {
      background: "#FFFFFF",
      boxShadow: "0px 3px 6px #00000029",
      zIndex: 460,
      marginTop: "auto",
      height: `calc(100vh - ${toolbarHeight}px - ${toolbarHeight}px + 2px)`,
      overflow: "scroll",
    },
    aboutTogglebarResponsive: {
      height: 68,
      background: "#FFFFFF",
      boxShadow: "0px 3px 6px #00000029",
      cursor: "pointer",
      zIndex: 100,
    },
    aboutToggleIconResponsive: {
      width: 37,
      height: 27,
      transform: "rotate(90deg)",
    },
    gaugePieContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: "10px",
    },
    startingTabIrrigation: {
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      width: "200px",
    },
    endingTabIrrigation: {
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      width: "200px",
    },
    irrigationContainer: {
      // paddingLeft: 54,
      // paddingRight: 54,
      // height: "60vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      //marginTop: "45px",
      marginBottom: "15px",
      flexDirection: "column",
      // height: `calc(100vh - 320px)`,
    },
    irrigationTabs: {
      flexBasis: "auto",
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      // marginBottom: "2vh",
      marginTop: -20,
    },
    polygonTabs: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      // marginBottom: "2vh",
      marginTop: 20,
    },
    areachartSEarchLocation: {
      display: "flex",
      flexDirection: "row",
      marginLeft: 90,
      marginBottom: 37,
      [theme.breakpoints.down("md")]: {
        marginLeft: 36,
      },
    },
    startingTabAreachart: {
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      width: "84px",
    },
    endingTabAreachart: {
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      width: "84px",
    },
    locationFilterBox: {
      marginRight: "20px",
    },
    priorityCheckboxLabel: {
      fontSize: 16,
      alignContent: "left",
    },
    groupName: {
      fontSize: 17,
      marginLeft: 10,
      fontWeight: "bold",
    },
    accordion: {
      border: "1px solid rgba(0, 0, 0, .125)",
      boxShadow: "none",
      "&:not(:last-child)": {
        borderBottom: 0,
      },
      "&:before": {
        display: "none",
      },
    },
    middleAccordion: {
      border: "5px solid rgba(0, 0, 0, .125)",
      boxShadow: "none",
      "&:not(:last-child)": {
        borderBottom: 0,
      },
      "&:before": {
        display: "none",
      },
    },
    accordionExpanded: {
      "&$expanded": {
        margin: 0,
      },
    },
    accordionSummary: {
      // backgroundColor: "rgba(0, 0, 0, .03)",
      borderBottom: "1px solid rgba(0, 0, 0, .125)",
      marginBottom: -1,
      minHeight: 53,
      "&$expanded": {
        minHeight: 53,
      },
      // flexDirection: "row-reverse",
      "& .icon": {
        fontSize: 12,
      },
    },
    accordionSummaryExpanded: {
      "& .MuiAccordionSummary-expandIcon": {
        // transform: "rotate(90deg)",
      },
    },
    accordionDetails: {
      // backgroundColor: "rgba(0, 0, 0, .03)",
      display: 'block !important', // Accordion Container has display: flex by default
      justifyContent: "center",
      // flexDirection: "column",
      // maxHeight: 185, // Removing scroll
      // scrollBehavior: "auto",
      // overflowY: "scroll",
      // padding: "0px 40px 10px 40px",
      
    },
    accordionDetailsGauge: {
      justifyContent: "center",
      maxHeight: 185, 
      scrollBehavior: "auto",
      overflowY: "scroll",
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.primary.main,
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.background.default,
        borderRadius: '4px',
      },
      
    },
    aboutContent: {
      marginTop: 16,
      fontSize: 13,
    },
    aboutScenario: {
      marginTop: 5,
      fontSize: 13,
    },
    aboutScenarioTitle: {
      marginTop: 16,
      fontSize: 13,
      fontWeight: "bold",
    },
    metricsContainer: {
      display: "flex",
      // justifyContent: "flex-start",
      height: '200px', 
      overflow: 'auto'
    },
    mapFilterGrid: {
      width: "120%",
      paddingLeft: "10px",
      display: "flex",
      justifyContent: "space-between",
    },
    mapFilterChips: {
      background: "#FFFFFF",
      borderRadius: "40px",
      cursor: "pointer",
      height: "40px",
      padding: "0 0 0 0",
      // marginLeft: "-10px",
    },
    mapFilterChipIcon: {
      height: "18px",
      marginRight: "10px",
      // paddingLeft: "20px",
    },
    mapFilterChipLabel: {
      color: "#757575",
      fontSize: "15px",
    },
    mapTitleBox: {
      display: "flex",
    },
    aboutSidebarResponsive: {
      background: "#000",
    },
    highchart: {
      display: "flex",
      marginLeft: "40px",
      flexGrow: 1,      
      [theme.breakpoints.down("md")]: {
        flexGrow: 0
      }
    },
    polymapView: {
      position: 'relative', 
      zIndex: 1, 
      width: '100%', 
      background: "#E5E9EE"
    },
    polymapContainer: {
      width: `calc(99vw - ${aboutDrawerWidth}px - ${chartTogglebarWidth}px)`,
      height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
      position: "absolute",
      top: 0,
      overflowY: "scroll",
      [theme.breakpoints.down("md")]: {
        position: "static",
        width: "100%",
        overflowY: "visible",
        height: `calc(100vh - ${toolbarHeight}px - ${filterToolbarHeight}px - ${aboutTogglebarWidth}px - 160px)`
      }
    }
  },
  { index: 999 }
);

export default useStyles;
